import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import {
  FetchScoreAllocationsPayload,
  ScoreAllocationListResponseRaw,
} from 'features/Yucollect/Score/types/Score.types';
import { put, takeLatest } from 'redux-saga/effects';
import {
  fetchScoreAllocationsFailure,
  fetchScoreAllocationsReq,
  fetchScoreAllocationsSuccess,
} from 'redux/slice/score/ScoreList.slice';
import { scoreEndpoints } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

function* fetchScoreAllocationsSaga({
  payload,
}: PayloadAction<FetchScoreAllocationsPayload>) {
  try {
    const { agencyId, page, pageSize } = payload;
    const response: AxiosResponse<ScoreAllocationListResponseRaw> =
      yield HTTPClient.GetRequest(
        scoreEndpoints.GET_SCORE_ALLOCATIONS(agencyId),
        { params: { page, pageSize } }
      );
    const raw = response.data;
    yield put(
      fetchScoreAllocationsSuccess({
        data: raw.data.map((item) => ({
          allocationId: item.allocation_id,
          allocationName: item.allocation_name,
          product: item.product,
          bucket: item.bucket,
          totalRecords: item.total_records,
          createdAt: item.created_at,
          scoreStatus: item.score_status,
          allocationScore: item.allocation_score,
        })),
        totalCount: raw.total_count,
        page: raw.page,
        pageSize: raw.page_size,
      })
    );
  } catch {
    yield put(
      fetchScoreAllocationsFailure('Failed to fetch score allocations')
    );
  }
}

export function* watchScoreListSagas() {
  yield takeLatest(fetchScoreAllocationsReq.type, fetchScoreAllocationsSaga);
}
